import PropTypes from 'prop-types';
import React from 'react';

import SpinnerWithContainer from '@glass/web/components/Loading/SpinnerWithContainer';
import BaseResumeTemplateV2 from '@glass/web/components/Resumes/templates/BaseResumeTemplateV2';
import resumeSize from '@glass/web/modules/resumes/templates/resumeSize';

import AspectRatio from '@glass/shared/components/AspectRatio/AspectRatio';
import ScaleWidth from '@glass/shared/components/AspectRatio/ScaleWidth';

const { width, height } = resumeSize;

function ResumePreview({ singlePage, loading, maxScale, ...otherProps }) {
  return loading ? (
    <AspectRatio height={height} width={width}>
      <SpinnerWithContainer />
    </AspectRatio>
  ) : (
    <ScaleWidth
      height={height}
      maxHeight={singlePage ? height : undefined}
      maxScale={maxScale}
      width={width}
    >
      {({ scale }) => <BaseResumeTemplateV2 {...otherProps} scale={scale} />}
    </ScaleWidth>
  );
}

ResumePreview.propTypes = {
  loading: PropTypes.bool,
  maxScale: PropTypes.number,
  singlePage: PropTypes.bool,
};

ResumePreview.defaultProps = {
  singlePage: false,
};

export default ResumePreview;
